/**
 * 安徽常道信息技术有限公司(2017~2020)
 * All Rights Reserved.
 *
 */


/**
 * 返回：
 * true 移动端（包括微信开发者工具）
 * false PC端
  */
var IsPc = function(){
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod", "wechatdevtools"];
    var flag = false;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = true;
            break;
        }
    }
    return flag;
}
export default IsPc;

